import { useFormContext } from 'react-hook-form';
import { Paper, Typography, Button } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useSchoolClass } from 'pages/SchoolClass/hooks/useSchoolClass';
import { SchoolClassFormData } from 'services/SchoolClass/schemas';

type SchoolClassHookReturn = ReturnType<typeof useSchoolClass>;

export interface SubCardProps {
  state: SchoolClassHookReturn['state'];
  actions: SchoolClassHookReturn['actions'];
}

export function DangerZoneCard({ state, actions }: SubCardProps) {
  const { getValues } = useFormContext<SchoolClassFormData>();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'error.dark',
        bgcolor: 'background.paper',
        mt: 'auto',
      }}
    >
      <Typography variant="subtitle1" fontWeight="bold" color="error.main" sx={{ mb: 1 }}>
        Ações da Turma
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Ao excluir esta turma, todos os vínculos com alunos e estatísticas de presença serão permanentemente removidos.
      </Typography>
      <Button
        color="error"
        variant="outlined"
        startIcon={<Delete />}
        onClick={(e) => actions.handleOpenDeleteModal(e, { 
          id: state.selectedId as number, 
          name: getValues('name')
        })}
        sx={{ textTransform: 'none', fontWeight: 'bold' }}
      >
        Excluir Turma
      </Button>
    </Paper>
  );
}